// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import store from './store/index' (Vuex Not implemented yet)

// Polyfill for URLSearchParams interface (IE11)
// https://www.npmjs.com/package/url-search-params-polyfill
import 'url-search-params-polyfill'

// Polyfills for IE11
import 'babel-polyfill'
// Support for IE10.
import 'core-js/es6/symbol'
import 'core-js/es6/object'
import 'core-js/es6/function'
import 'core-js/es6/parse-int'
import 'core-js/es6/parse-float'
import 'core-js/es6/number'
import 'core-js/es6/math'
import 'core-js/es6/string'
import 'core-js/es6/date'
import 'core-js/es6/array'
import 'core-js/es6/regexp'
import 'core-js/es6/map'
import 'core-js/es6/weak-map'
import 'core-js/es6/set'

// Polyfill for ES6-Promise (IE11)
// require('es6-promise').polyfill()

Vue.config.productionTip = false

// Global Event Bus
// https://alligator.io/vuejs/global-event-bus/
const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app_commercial_guide',
  // store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js